module.exports = __webpack_public_path__ + "img/toutou_song_3.b81d2418.jpg";